import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Configurator } from 'src/app/_data/configurator';
import { Router } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { GlobalService } from 'src/app/_services/global.service';
import { BusinessSetupService } from 'src/app/_services/business-setup.service';
import { UserService } from 'src/app/_services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomersService } from 'src/app/_services/customers.service';
import { LocationsService } from 'src/app/_services/locations.service';
import { ProductsService } from 'src/app/_services/products.service';
import { ConfigService } from 'src/app/service/app.config.service';
import { ProductService } from 'src/app/service/productservice';
import { environment } from 'src/environments/environment';
import { formatDate } from '@angular/common';
import { BaseService } from 'src/app/_services/base.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-configurator',
    templateUrl: './configurator.component.html',
    styleUrls: ['./configurator.component.scss']
})

export class ConfiguratorComponent implements OnInit, OnDestroy {
  sections: any[] = Configurator;
  ShowShippingOption: boolean = false;
  
  @ViewChild('basicShippingComponent') basicShippingComponent: any;
  
  // Shipping Settings Form
  shippingSettingsForm!: FormGroup;
  private destroy$ = new Subject<void>();
ShowPaymentOption: any;
    ShowSetupProgressOnDashboard: boolean;


    constructor(
     
        private _bs: BaseService,
        private productService: ProductService,
        public configService: ConfigService,
        private _router: Router,
        private _spinner: NgxSpinnerService,
        public _abd: AppBaseDataService,
        private _locationServices: LocationsService,
        private _productServices: ProductsService,
        private _customerServices: CustomersService,
        private _invoiceServices: ProductsService,
        private sanitizer: DomSanitizer,
        // Lincsell---
        private _businessServices: BusinessSetupService,
        private _userServices: UserService,
        private fb: FormBuilder,
    ) {
        console.log(GlobalService.StepStatus);
        this.initializeShippingForm();
    }

    private initializeShippingForm(): void {
      this.shippingSettingsForm = this.fb.group({
        shippingEnabled: [false],
        rateType: ['flat'],
        shippingCost: [0]
      });
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }


    setTaskStatus(taskID: string, status: boolean): void {
        
        const task = GlobalService.StepStatus.find(item => item.taskID === taskID);
        if (task) {
            task.isCompleted = status;
        } else {
            // If taskID doesn't exist, add it to the array
            GlobalService.StepStatus.push({ taskID, isCompleted: status });
        }
    }

    checkIfStepCompleted(taskInput: string | { taskID: string }[]): boolean {
      
        if (typeof taskInput === 'string') {
            const task = GlobalService.StepStatus.find(item => item.taskID === taskInput);
            return task ? task.isCompleted : false;
        } else if (Array.isArray(taskInput)) {
            for (const taskObj of taskInput) {
                const task = GlobalService.StepStatus.find(item => item.taskID === taskObj.taskID);
                if (!task || !task.isCompleted) {
                    return false;
                }
            }
            return true;
        }

        return false;
    }

    getShippingConfiguration() {
        // Lincsell---
        this._businessServices.getShippingConfiguration().subscribe((res) => {
            if (res.success) {
                if (res.data?.zones && res.data?.zones?.length > 0) {
                    this.setTaskStatus("T007", true)
                } else {
                    this.setTaskStatus("T007", false)
                }
            }
        }, (error) => {
            this.setTaskStatus("T007", false)
        })
    }
    getPaymentProcessing() {
        // Lincsell---
        return;
        try {
            
            if (GlobalService.userInfo.businessSetup[0].stripeOnboardingStatus==="Completed" ) {
                this.setTaskStatus("T008", true)
            }
            else {
                this.setTaskStatus("T008", false)
            }
        }
        catch {
            this.setTaskStatus("T008", false)

        }


        // this._businessServices.getPaymentProcessing().subscribe((res) => {
        //     if (res.success) {

        //         if (res.data.isSaved === true) {
        //             this.setTaskStatus("T008", true)
        //         } else {
        //             this.setTaskStatus("T008", false)
        //         }
        //     }
        // }, (error) => {
        //     this.setTaskStatus("T008", false)
    //}
    //)
}

checkStripeAccountStatus(): void {
    // Check payment/Stripe account status
    this._businessServices.CheckConnectAccount().subscribe(
      (response) => {
        if (response.success) {
          const isStripeConnected = response.data.chargesEnabled || false;
          const stripeStatus = response.data.status;
          
          // Update task status based on Stripe connection
          if (isStripeConnected || 1==1) {
            this.setTaskStatus("T008", true);
            console.log('✓ Stripe account is connected:', stripeStatus);
          } else {
            this.setTaskStatus("T008", false);
            console.warn('⚠ Stripe account is not fully enabled:', stripeStatus);
          }
        } else {
          this.setTaskStatus("T008", false);
          console.warn('⚠ Stripe check returned unsuccessful response:', response);
        }
      },
      (error) => {
        this.setTaskStatus("T008", false);
        console.warn('⚠ Error checking Stripe account status:', error);
      }
    );
}
///settings status

getLocations() {
    // Now handled by getLocationsAsync() in ngOnInit
    const loc = this._abd.locations?.filter(f => !f.isDeleted && f.active) || [];
    this.setTaskStatus("T001", loc?.length > 0);
}

getInventory() {
    // Now handled by getInventoryAsync() in ngOnInit
    let obj = {
        "PageNo": 0,
        "PageSize": 1,
    }
    this._productServices.getAllProductList4Inventory(obj).subscribe((res) => {
        if (res.success) {
            this.setTaskStatus("T002", res.data.length > 0)
        }
    }, (error) => {
        this.setTaskStatus("T002", false);
    })
}
getWebConfigration() {
    try {

        this._userServices.getWebStoreConfiguration().subscribe((res) => {
            if (res.success) {
                
                GlobalService.webStoreConfiguration = res.data;
                if (Array.isArray(GlobalService.webStoreConfiguration)) {
                    let iswebStoreSelectedDefault: boolean = false
                    iswebStoreSelectedDefault = GlobalService.webStoreConfiguration.filter(v => v.isDefault === true)?.length > 0 ? true : false
                    if (GlobalService.webStoreConfiguration.length > 0 && !iswebStoreSelectedDefault) {
                        this.setTaskStatus("T005", false);
                    } else {
                        this.setTaskStatus("T005", true);
                    }
                     this.updateCompletedTasksForAllSections();
                } else if (typeof GlobalService.webStoreConfiguration === 'object' && GlobalService.webStoreConfiguration !== null) {
                    this.setTaskStatus("T005", true);
                     this.updateCompletedTasksForAllSections();
                }

            }
        })
    } catch (error) {
        this.setTaskStatus("T005", false);
    }


}

ngOnInit(): void {
    // Run all step progress checks independently in parallel
    Promise.all([
      this.getInventoryAsync(),
      this.getWebConfigrationAsync(),
      this.getShippingConfigurationAsync(),
      this.checkDownloadPOSAsync(),
      this.checkStripeAccountStatusAsync(),
      this.getLocationsAsync(),
      this.getInvoiceAsync()
    ]).then(() => {
      // All API calls completed - now check setup progress and update UI
      this.checkAllStepsAndShowSetupProgress();
      this.updateCompletedTasksForAllSections();
      console.log('✓ All setup checks completed');
    }).catch((error) => {
      console.error('Error during setup checks:', error);
      // Still check and update UI even if some calls failed
      this.checkAllStepsAndShowSetupProgress();
      this.updateCompletedTasksForAllSections();
    });
    
    // Periodically refresh step status and check if setup is complete
    setInterval(() => {
      this.checkAllStepsAndShowSetupProgress();
      this.updateCompletedTasksForAllSections();
    }, 250000);
}

/**
 * Async wrapper for inventory check
 */
private getInventoryAsync(): Promise<void> {
  return new Promise((resolve) => {
    let obj = {
      "PageNo": 0,
      "PageSize": 1,
    }
    this._productServices.getAllProductList4Inventory(obj).subscribe(
      (res) => {
        if (res.success) {
          this.setTaskStatus("T002", res.data.length > 0)
        }
        resolve();
      },
      (error) => {
        this.setTaskStatus("T002", false);
        resolve();
      }
    );
  });
}

/**
 * Async wrapper for web configuration check
 */
private getWebConfigrationAsync(): Promise<void> {
  return new Promise((resolve) => {
    try {
      this._userServices.getWebStoreConfiguration().subscribe(
        (res) => {
          if (res.success) {
            GlobalService.webStoreConfiguration = res.data;
            if (Array.isArray(GlobalService.webStoreConfiguration)) {
              let iswebStoreSelectedDefault: boolean = false
              iswebStoreSelectedDefault = GlobalService.webStoreConfiguration.filter(v => v.isDefault === true)?.length > 0 ? true : false
              if (GlobalService.webStoreConfiguration.length > 0 && !iswebStoreSelectedDefault) {
                this.setTaskStatus("T005", false);
              } else {
                this.setTaskStatus("T005", true);
              }
            } else if (typeof GlobalService.webStoreConfiguration === 'object' && GlobalService.webStoreConfiguration !== null) {
              this.setTaskStatus("T005", true);
            }
          }
          resolve();
        },
        (error) => {
          this.setTaskStatus("T005", false);
          resolve();
        }
      );
    } catch (error) {
      this.setTaskStatus("T005", false);
      resolve();
    }
  });
}

/**
 * Async wrapper for shipping configuration check
 */
private getShippingConfigurationAsync(): Promise<void> {
  return new Promise((resolve) => {
    this._businessServices.getShippingConfiguration().subscribe(
      (res) => {
        if (res.success) {
          if (res.data?.zones && res.data?.zones?.length > 0) {
            this.setTaskStatus("T007", true)
          } else {
            this.setTaskStatus("T007", false)
          }
        }
        resolve();
      },
      (error) => {
        this.setTaskStatus("T007", false)
        resolve();
      }
    );
  });
}

/**
 * Async wrapper for POS download check
 */
private checkDownloadPOSAsync(): Promise<void> {
  return new Promise((resolve) => {
    if (this._abd.registers.length > 0) {
      this.setTaskStatus("T011", true);
    } else {
      this.setTaskStatus("T011", false);
    }
    resolve();
  });
}

/**
 * Async wrapper for Stripe account status check
 */
private checkStripeAccountStatusAsync(): Promise<void> {
  return new Promise((resolve) => {
    this._businessServices.CheckConnectAccount().subscribe(
      (response) => {
        if (response.success) {
          const isStripeConnected = response.data.chargesEnabled || false;
          if (isStripeConnected ) {
            this.setTaskStatus("T008", true);
            console.log('✓ Stripe account is connected');
          } else {
            this.setTaskStatus("T008", false);
          }
        } else {
          this.setTaskStatus("T008", false);
        }
        resolve();
      },
      (error) => {
        this.setTaskStatus("T008", false);
        resolve();
      }
    );
  });
}

/**
 * Async wrapper for locations check
 */
private getLocationsAsync(): Promise<void> {
  return new Promise((resolve) => {
    const loc = this._abd.locations?.filter(f => !f.isDeleted && f.active) || [];
    this.setTaskStatus("T001", loc?.length > 0);
    resolve();
  });
}

/**
 * Async wrapper for invoice check
 */
private getInvoiceAsync(): Promise<void> {
  return new Promise((resolve) => {
    let obj = {
      PageNo: 0,
      PageSize: 1,
      orderPlacement:'All',
      invoiceType:-1,
      locationIds:[],
      startDate: formatDate("01/01/1800" , 'MM/dd/yyyy', 'en-US'),
      endDate: formatDate(new Date(), 'MM/dd/yyyy', 'en-US'),
    }
    let url = environment.OrderBaseURL + environment.FilterInvoiceHistory
    this._bs.httpPost(url, obj).subscribe(
      (res) => {
        if (res.success) {
          if (res.data.length > 0) {
            this.setTaskStatus("T012", true);
          } else {
            this.setTaskStatus("T012", false);
          }
        }
        resolve();
      },
      (error) => {
        this.setTaskStatus("T012", false);
        resolve();
      }
    );
  });
}

/**
 * Check if any completed step is incomplete and set dashboard flag
 * Shows setup progress on dashboard if any step is incomplete
 */
private checkAllStepsAndShowSetupProgress(): void {
  try {
    // Get completion status for all required steps
    // These were just set by the async methods in Promise.all()
    const requiredSteps = ['T001', 'T002', 'T005', 'T007', 'T008', 'T011', 'T012'];
    const stepStatuses = {};
    let anyIncomplete = false;

    for (const stepId of requiredSteps) {
      const isComplete = this.checkIfStepCompleted(stepId);
      stepStatuses[stepId] = isComplete;
      if (!isComplete) {
        anyIncomplete = true;
      }
    }

    // Log step statuses for debugging
    console.log('Setup Progress Check:', stepStatuses);

    // Set global flag: show setup progress if ANY step is incomplete
    this.ShowSetupProgressOnDashboard = anyIncomplete;

    if (!anyIncomplete) {
      console.log('✓ All setup steps completed - hiding setup progress');
    } else {
      console.log('⚠ Some setup steps incomplete - showing setup progress');
    }
  } catch (error) {
    console.error('Error checking setup progress:', error);
    // Default to showing setup progress if there's an error
    this.ShowSetupProgressOnDashboard = true;
  }
}
ShowPOSLinks:boolean=false;
ShowCustomerAppDemo:boolean=false;
updateCompletedTasksForAllSections(): void {
  Configurator.forEach(section => {
    section.completedTasks = section.tasks.filter(
      (task: any) => this.checkIfStepCompleted(task.taskID)
    ).length;
    section.isCompleted=section.tasks.length-section.completedTasks==0;
  });
}

calculateOverallProgress(): number {
  let totalTasks = 0;
  let completedTasks = 0;
  
  Configurator.forEach(section => {
    totalTasks += section.totalTasks;
    completedTasks += section.completedTasks;
  });
  
  return totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;
}

calculateCompletedTasksCount(): number {
  let count = 0;
  Configurator.forEach(section => {
    count += section.completedTasks;
  });
  return count;
}

calculateTotalTasksCount(): number {
  let count = 0;
  Configurator.forEach(section => {
    count += section.totalTasks;
  });
  return count;
}

getHeaderTemplate(section: any): string {
  return `${section.title} - ${section.completedTasks}/${section.totalTasks}`;
}

_globals: GlobalService
toggleSection(section: any) {
    section.collapsed = !section.collapsed
}
getCompletedTasks(section: any): number {
     var yay=section.tasks.filter(t => this.checkIfStepCompleted(t.taskID)).length;
    console.log(yay);
  return yay;
}
getpendingTasks(section: any): number {
    var not=section.tasks.filter(t => this.checkIfStepCompleted(t.taskID)==false).length;
    console.log(not);
  return not;
}
performAction(task) {
    if (task.actionType == "ShowPOSLinks") {
        this.ShowPOSLinks=true;
    } else if (task.actionType == "supportinfopopup") {
        GlobalService.ShowHelpSidebar=true;
    }
     else if (task.actionType == "customerappdemo") {
        this.ShowCustomerAppDemo=true;
    }
    else if (task.actionType == "InternalLink") {
        if (task.actionLink == "app/business/shipping") {
            this.ShowShippingOption=true;
        }
        else if (task.actionLink == "app/business/payment-processing") {
            this.openPaymentProcessing("")
        } else if (task.actionLink == "app/business/tax") {
            this.openTaxConfig("")
        }
        else if (task.actionLink == "app/products") {
            this.openInventory("")
        }
        else if (task.actionLink == "select-template") {
            this.openWebConfigration("")
        }
        else if (task.actionLink == "app/payment-processing-instore") {
           this.ShowPaymentOption=true;
        }
        else
            this._router.navigate([task.actionLink]);
    }
}
openLocation(value) {
    if (value === false) {
        this._router.navigate(['app/locations-list'])
    }
}
 checkDownloadPOS(){

        if(this._abd.registers.length > 0){
                       this.setTaskStatus("T011", true);
                    }else{
                       this.setTaskStatus("T011", false);

        }
    }
    getCustomers(){
            let obj ={
                "PageNo": 0,
                "PageSize": 1,
                "type":"all"
           }
            this._customerServices.getAllCustomers(obj).subscribe((res)=>{
                 if(res.success){
                    if(res.data.length >0){
                        this.setTaskStatus("T011", false);
                    }else{
                        this.setTaskStatus("T011", false);
                    }
                 }
            },(error)=>{
                // console.log(error)
                this.setTaskStatus("T011", false);
            }
            )
        }
        getInvoice(){
            let obj ={
                PageNo: 0,
                PageSize: 1,
                orderPlacement:'All',
                invoiceType:-1,
                locationIds:[],
                startDate: formatDate("01/01/1800" , 'MM/dd/yyyy', 'en-US'),
                endDate: formatDate(new Date(), 'MM/dd/yyyy', 'en-US'),
           }
           let url = environment.OrderBaseURL + environment.FilterInvoiceHistory
           this._bs.httpPost(url, obj).subscribe(res => {
            // this._locationServices.getAllLocations(obj).subscribe((res)=>{
                 if(res.success){
                    if(res.data.length >0){
                        this.setTaskStatus("T012", true);
                    }else{
                        this.setTaskStatus("T012", false);
                    }
                 }
            },(error)=>{
                // console.log(error)
                this.setTaskStatus("T012", false);
            }
            )
        }

openInventory(value) {
    // if(value === false){
    this._router.navigate(['app/products'])
    // }
}
openCustomer(value) {
    if (value === false) {
        this._router.navigate(['app/customers'])
    }
}
openShippingConfig(value) {
   this.ShowShippingOption=true;

}
openWebConfigration(value) {
    if (Array.isArray(GlobalService.webStoreConfiguration)) {
        this._router.navigate(["select-template"])
    } else if (typeof GlobalService.webStoreConfiguration === 'object' && GlobalService.webStoreConfiguration !== null) {
        window.open(GlobalService.webStoreConfiguration.demoUrl, '_blank')
    }
}
openPaymentProcessing(value) {
    this.ShowPaymentOption=true;
   

}
openTaxConfig(value) {
    this._router.navigate(['app/business'], {
        queryParams: { page: 'Taxconfig' }
    });

}
openInvoice(value) {
    if (value === false) {
        // this._router.navigate(['app/sales-invoices'])
    }
}

openPosAppDownload(value) {
    // this._abd.isDownloadPosApp = true;
    // this.isPosAppDownload = true;
    // sessionStorage.setItem('pos-app-download', '1')
    // this.checkDownloadPOS()
}

goToEditer() {
    window.open(GlobalService.webStoreConfiguration.demoUrl, '_blank')
}

/**
 * Handles shipping configuration form submission
 */
shippingSettingCompleted(formValue: any): void {
    console.log('Shipping settings saved:', formValue);
    // Mark task as completed
    this.setTaskStatus('T007', true);
    // Refresh the progress bar UI
    this.updateCompletedTasksForAllSections();
    // Check if all setup steps are now complete
    this.checkAllStepsAndShowSetupProgress();
    // Close sidebar
    this.ShowShippingOption = false;
    // Optional: Show success message
    // this._messageService.add({ severity: 'success', summary: 'Shipping Configuration', detail: 'Shipping settings saved successfully!' });
}

/**
 * Handles shipping configuration form changes
 */
onShippingFormChanged(formValue: any): void {
    console.log('Shipping form changed:', formValue);
    // You can perform real-time validations or updates here
}

/**
 * Initialize the basic shipping component when the sidebar is shown
 */
onShippingModalShow(): void {
    if (this.basicShippingComponent) {
        this.basicShippingComponent.initializeComponent();
    }
}
    
}
